import { clsx } from 'clsx'
import { type FC } from 'react'
import {
  useClearRefinements,
  type UseClearRefinementsProps,
} from 'react-instantsearch'
import { FormattedMessage } from 'react-intl'

import { IconTrashDelete } from '@redteclab/icons'

import { Button } from 'base-ui'

export const ProductSearchRefinementClearAllRefinements: FC = (
  props: UseClearRefinementsProps,
) => {
  const { canRefine, refine } = useClearRefinements(props)

  const disabled = !canRefine

  const handleResetClick = (): void => {
    refine()
  }

  return (
    <Button
      className={clsx('mx-0', 'px-0', canRefine && 'text-dark-brand')}
      data-qa-id="form-clear-filter-product-filter"
      disabled={disabled}
      onClick={handleResetClick}
      size="medium"
      startIcon={<IconTrashDelete />}
      variant="text"
    >
      <span className="font-medium">
        <FormattedMessage id="searchResults.label.clearAllFilters" />
      </span>
    </Button>
  )
}
